export default __webpack_public_path__ + "img/c7ec66e2acc04df1eac510aaf2af2a11.svg";